var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-form-group"},[_c('assistentTitle',{attrs:{"data":_vm.data,"callback":_vm.setTitle,"settings":_vm.settings}})],1),_c('div',{staticClass:"flix-form-group"},[(_vm.title)?_c(_vm.data.type,{tag:"component",attrs:{"data":_vm.data,"callback":_vm.saveData}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }